import { defineMessages, IntlFormatters } from "react-intl";
import { PitchNotation } from "../../front/store/user/models";

const pitchNotationValues = [
    PitchNotation.Helmholtz,
    PitchNotation.International,
    PitchNotation.UppercaseLetter,
    PitchNotation.UppercaseHelmholtz
];

export const pitchNotationOptions = (fm: IntlFormatters["formatMessage"]) =>
    pitchNotationValues.map(value => ({
        value,
        label: fm(
            defineMessages({
                message: {
                    id: `pitchNotation.${value}`,
                },
            }).message
        ),
    }));

export const parseWithPitchNotation = (letter: string, pitchNotation: PitchNotation) => {
    switch (pitchNotation) {
        case PitchNotation.UppercaseHelmholtz:
            return letter.slice(0, 1).toUpperCase() + letter.slice(1);
        case PitchNotation.UppercaseLetter:
            return letter.slice(0, 1).toUpperCase() + letter.slice(1).replace(/’/, "");
        case PitchNotation.International:
            return (
                letter.slice(0, 1).toUpperCase() +
                letter.slice(1).replace("’’’", "6").replace("’’", "5").replace("’", "4").replace(",", "1") +
                (letter.indexOf(",") === -1 && letter.indexOf("’") === -1
                    ? letter.slice(0, 1) === letter.slice(0, 1).toLowerCase()
                        ? "3"
                        : ""
                    : "") +
                (letter.indexOf(",") === -1 && letter.indexOf("’") === -1
                    ? letter.slice(0, 1) === letter.slice(0, 1).toUpperCase()
                        ? "2"
                        : ""
                    : "")
            );
        default:
            return letter;
    }
};